// extracted by mini-css-extract-plugin
export default {"FormContainer":"FormContainer_FormContainer__eueuU"};